import { type ThemeOptions } from '@mui/material';

export const palette: ThemeOptions['palette'] = {
  primary: {
    main: '#FF5A00',
  },
  status: {
    success: '#39BE00',
    error: '#DC0000',
    warning: '#ffc107',
    info: '#0dcaf0',
  },
  brand: {
    main: '#FF5A00',
  },
  border: {
    main: '#D6D6D6',
  },
  grey: {
    100: '#F1F1F1',
    200: '#EFEFEF',
    300: '#D6D6D6',
    400: '#AFAFAF',
    500: '#898989',
    600: '#656565',
    700: '#434343',
  },
  lightBlue: '#E5E7EB',
  beige: '#FAF8F0',
};
